import type { CustomIconProps } from '../types';

const DropdownArrowOpen = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '6'}
        viewBox="0 0 12 6"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8559 0.124846C12.0409 0.297882 12.0488 0.586221 11.8735 0.76887L7.26227 5.57324C6.73584 6.12173 5.85841 6.14453 5.30345 5.62416L0.143655 0.785842C-0.0411478 0.612553 -0.0486384 0.324203 0.126924 0.141794C0.302487 -0.0406147 0.594621 -0.0480083 0.779424 0.12528L5.93922 4.9636C6.12421 5.13706 6.41669 5.12945 6.59216 4.94663L11.2034 0.142252C11.3787 -0.0403968 11.6708 -0.0481897 11.8559 0.124846Z"
            fill="#414042"
        />
    </svg>
);

export default DropdownArrowOpen;
